import { useCurrentUser } from '@mp/hooks';
import { yup } from '@medely/ui-kit';
import { yupResumeFileValidator } from '@mp/utils/fileValidation';
import useResumeSubmitMutation, { ResumeValue } from './useResumeMutations';

type UseResumeModalParams = {
  onClose: () => void;
  buildFormData: (file: NonNullable<ResumeValue>) => FormData;
  headers?: Record<string, string>;
};

export const useResumeModal = ({ onClose, buildFormData, headers }: UseResumeModalParams) => {
  const { currentUser } = useCurrentUser();
  const { submitResume, isLoading } = useResumeSubmitMutation({
    onClose,
    buildFormData,
    headers,
  });

  const resume = currentUser?.professional?.resume;

  const handleContinue = (values: { resume: ResumeValue }) => {
    submitResume(values);
  };

  const schema = yup.object({
    resume: yup
      .mixed()
      .nullable()
      .test(
        'resume-required',
        'Required',
        (value) => value !== null && value !== undefined && value !== '',
      )
      .test('resume-validation', (value) => yupResumeFileValidator(value, true)),
  });

  return { resume, schema, handleContinue, isLoading };
};
